import store from '@/store'

const has = function (value) {
  const controls = store.getters.controls
  const appNo = store.getters.appNo
  if (!controls) {
    return true
  }
  if (!controls[value['form'] + appNo]) {
    return false
  }
  return controls[value['form'] + appNo][value['control']] !== undefined
}

export default{
  bind (el, binding, vnode) {
    if (!has(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permissionBtn/index.js